import axios from "axios";
import { API } from "@/lib/api";

// Public (guest) API — no auth interceptor. Case access is via per-case token.
export const publicApi = axios.create({ baseURL: API });

export const EVAL_KEY = "accurate_eval_case";

export function saveEval(id, token) {
  localStorage.setItem(EVAL_KEY, JSON.stringify({ id, token }));
}
export function loadEval() {
  try { return JSON.parse(localStorage.getItem(EVAL_KEY)); } catch { return null; }
}
export function clearEval() {
  localStorage.removeItem(EVAL_KEY);
}
